/**
 * index.js
 *
 *
 * Main app file containing a contect provider, routing and page layout.
 */

import "antd/dist/antd.min.css"; // or 'antd/dist/antd.less'
import React from "react";
import { render } from "react-dom";
import TagManager from "react-gtm-module";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import NotFound from "./components/404/NotFound";
import PageLayout from "./components/reusable/PageLayout/PageLayout";
import "./custom-antd.css";
import { ContextProvider } from "./hooks/context";
import "./index.css";
import ABCProtocol from "./pages/ABCProtocol/ABCProtocol";
import AboutUs from "./pages/AboutUs/AboutUs";
import Conversation from "./pages/Conversation/Conversation";
import Experiments from "./pages/Experiments/Experiments";
import Home from "./pages/Home/Home";
import MixedFeelings from "./pages/MixedFeelings/MixedFeelings";
import PNUDBook from "./pages/PNUDBook/PNUDBook";
import Prensa from "./pages/Prensa/Prensa";
import Publication from "./pages/Publication/Publication";
import Resources from "./pages/Resources/Resources";
import Surveys from "./pages/Surveys/Surveys";
import Xenophobia from "./pages/Xenophobia/Xenophobia";
import * as serviceWorker from "./serviceWorker";
import "./style.css";

const tagManagerArgs = {
  gtmId: "GTM-M4DCMK4",
};

TagManager.initialize(tagManagerArgs);

render(
  <HashRouter>
    <ContextProvider>
      <PageLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experimentos" element={<Experiments />} />
          <Route
            path="/conversacion"
            element={<Navigate to={"/conversacion/LAC"} replace={true} />}
          />
          <Route
            path="/glosario"
            element={
              <Navigate to={"/conversacion/LAC/glosario"} replace={true} />
            }
          />
          <Route path="/conversacion/:country" element={<Conversation />} />
          <Route
            path="/conversacion/:country/:openGlossary"
            element={<Conversation />}
          />
          <Route path="/encuestas" element={<Surveys />} />
          <Route path="/encuestas/:country" element={<Surveys />} />
          <Route 
            path="/prensa" 
            element={
              <Navigate to={"/prensa/LAC"} replace={true}/>
            }
          />
          <Route path="/prensa/:country" element={<Prensa />} />
          <Route path="/toolkit" element={<Xenophobia />} />
          <Route path="/mixed-feelings" element={<MixedFeelings />} />
          <Route path="/recursos" element={<Resources />} />
          <Route path="/sobre" element={<AboutUs />} />
          <Route path="/publicacion/bid_pnud_2021" element={<PNUDBook />} />
          <Route path="/publicacion/abc_protocol" element={<ABCProtocol />} />
          <Route path="/publicacion/:pubId" element={<Publication />} />
          <Route path="/en" element={<Home />} />
          <Route path="/en/experimentos" element={<Experiments />} />
          <Route
            path="/en/conversacion"
            element={<Navigate to={"/en/conversacion/LAC"} replace={true} />}
          />
          <Route
            path="/en/glosario"
            element={
              <Navigate to={"/en/conversacion/LAC/glosario"} replace={true} />
            }
          />
          <Route path="/en/conversacion/:country" element={<Conversation />} />
          <Route
            path="/en/conversacion/:country/:openGlossary"
            element={<Conversation />}
          />
          <Route path="/en/encuestas" element={<Surveys />} />
          <Route path="/en/encuestas/:country" element={<Surveys />} />
          <Route
            path="/en/prensa"
            element={<Navigate to={"/en/prensa/LAC"} replace={true} />}
          />
          <Route path="/en/prensa/:country" element={<Prensa />} />
          <Route path="/en/toolkit" element={<Xenophobia />} />
          <Route path="/en/mixed-feelings" element={<MixedFeelings />} />
          <Route path="/en/recursos" element={<Resources />} />
          <Route path="/en/sobre" element={<AboutUs />} />
          <Route path="/en/publicacion/bid_pnud_2021" element={<PNUDBook />} />
          <Route path="/en/publicacion/abc_protocol" element={<ABCProtocol />} />
          <Route path="/en/publicacion/:pubId" element={<Publication />} />
          <Route path="/es" element={<Home />} />
          <Route path="/es/experimentos" element={<Experiments />} />
          <Route
            path="/es/conversacion"
            element={<Navigate to={"/es/conversacion/LAC"} replace={true} />}
          />
          <Route
            path="/es/glosario"
            element={
              <Navigate to={"/en/conversacion/LAC/glosario"} replace={true} />
            }
          />
          <Route path="/es/conversacion/:country" element={<Conversation />} />
          <Route
            path="/es/conversacion/:country/:openGlossary"
            element={<Conversation />}
          />
          <Route path="/es/prensa" 
            element={<Navigate to={"/es/prensa/LAC"} replace={true} />}
          />
          <Route path="/es/mixed-feelings" element={<MixedFeelings />} />
          <Route path="/es/prensa/:country" element={<Prensa />} />
          <Route path="/es/encuestas" element={<Surveys />} />
          <Route path="/es/encuestas/:country" element={<Surveys />} />
          <Route path="/es/recursos" element={<Resources />} />
          <Route path="/es/toolkit" element={<Xenophobia />} />

          <Route path="/es/sobre" element={<AboutUs />} />
          <Route path="/es/publicacion/bid_pnud_2021" element={<PNUDBook />} />
          <Route path="/es/publicacion/abc_protocol" element={<ABCProtocol />} />
          <Route path="/es/publicacion/:pubId" element={<Publication />} />
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </PageLayout>
    </ContextProvider>
  </HashRouter>,
  document.getElementById("root")
);

serviceWorker.unregister();
